
const app = {
    namespaced: true,

    state: {
        loading: false,
        drawerMenu: false,
        leftbar: null,
    },

    mutations: {

        SET_LOADING(state, vis) {
            state.loading = vis
        },

        apriDrawer(state, data) {
            state.drawerMenu = !state.drawerMenu
        },
        setDrawer(state, data) {
            state.drawerMenu = data;
        },
    },



    getters: {
        getDrawerMenu(state) {
            return state.drawerMenu
        },
    }


}

export default app